export default __webpack_public_path__ + "bc9cd260849fca34baef85a24188aece.png";